import {
    CREATE_GENERAL_DC_DETAILS_REQUEST,
    CREATE_GENERAL_DC_DETAILS_SUCCESS,
    CREATE_GENERAL_DC_DETAILS_FAILURE,
    DELETE_GENERAL_DC_DETAILS_REQUEST,
    DELETE_GENERAL_DC_DETAILS_SUCCESS,
    DELETE_GENERAL_DC_DETAILS_FAILURE,
    FETCH_SINGLE_GENERAL_DC_DETAILS_REQUEST,
    FETCH_SINGLE_GENERAL_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_GENERAL_DC_DETAILS_FAILURE,
    FETCH_GENERAL_DC_DETAILS_REQUEST,
    FETCH_GENERAL_DC_DETAILS_SUCCESS,
    FETCH_GENERAL_DC_DETAILS_FAILURE,
    UPDATE_GENERAL_DC_DETAILS_REQUEST,
    UPDATE_GENERAL_DC_DETAILS_SUCCESS,
    UPDATE_GENERAL_DC_DETAILS_FAILURE,
    RESET_GENERAL_DC_DETAILS_INFO,
    CREATE_GENERAL_DC_DETAILS_FORM,
    UPDATE_GENERAL_DC_DETAILS_FORM,
    FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_SUCCESS,
    FETCH_GENERAL_DC_DETAILS_APPROVAL_STATUS_REQUEST,
    FETCH_GENERAL_DC_DETAILS_APPROVAL_STATUS_SUCCESS,
    FETCH_GENERAL_DC_DETAILS_APPROVAL_STATUS_FAILURE,
    FETCH_GENERAL_DC_DETAILS_SUCCESS_GET,
    RESET_DEFAULT_USERFORM_DETAILS_FORM,
    FETCH_MISCELLANEOUS_ITEM_REQUEST,
    FETCH_MISCELLANEOUS_ITEM_FAILURE,
    FETCH_MISCELLANEOUS_ITEM_SUCCESS,
    RESET_ADMIN_DC_DETAILS_INFO,
} from './generalDcDetails.actionsType';

export const GENERAL_DC_DETAILS = 'generalDcDetails';

let initialState = {
    loading: false,
    generalPoDetails: [],
    generalDcdetails: [],
    generalPoDetailsWithoutId: [],
    generalPoDetailsForm: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedState: {},
    errorMessage: ''
};

export let generalDcDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_GENERAL_DC_DETAILS_REQUEST:
        case CREATE_GENERAL_DC_DETAILS_REQUEST:
        case UPDATE_GENERAL_DC_DETAILS_REQUEST:
        case FETCH_SINGLE_GENERAL_DC_DETAILS_REQUEST:
        case DELETE_GENERAL_DC_DETAILS_REQUEST:
        case FETCH_GENERAL_DC_DETAILS_APPROVAL_STATUS_REQUEST:
        case FETCH_MISCELLANEOUS_ITEM_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_GENERAL_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoDetails: updatePayload
            };
        case FETCH_GENERAL_DC_DETAILS_APPROVAL_STATUS_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoDetailsWithoutId: updatePayload
            };
        case FETCH_MISCELLANEOUS_ITEM_SUCCESS:
            return {
                ...state,
                loading: false,
                miscellaneous: updatePayload
            };
        case FETCH_GENERAL_DC_DETAILS_SUCCESS_GET:
            return {
                ...state,
                loading: false,
                generalDcdetails: updatePayload
            }
        case CREATE_GENERAL_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                // generalPoDetailsForm: {
                //     fldRate: 0,
                //     fldQuantity: 0,
                //     fldGrossValue: 0,
                //     fldDiscountValue: 0,
                //     fldIGSTValue: 0,
                //     fldSGSTValue: 0,
                //     fldCGSTValue: 0,
                //     fldTaxableValue: 0,
                //     fldGSTValue: 0,
                //     fldSGSTPercentage: 0,
                //     fldCGSTPercentage: 0,
                //     fldIGSTPercentage: 0
                // }
            };
        case UPDATE_GENERAL_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_SINGLE_GENERAL_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: updatePayload
            };
        case RESET_DEFAULT_USERFORM_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: []
            }
        case DELETE_GENERAL_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case RESET_GENERAL_DC_DETAILS_INFO:
            return {
                ...state,
                generalPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,

                }
            };
        case RESET_ADMIN_DC_DETAILS_INFO:
            return {
                ...state,
                generalPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKGeneralItem: state.generalPoDetailsForm?.fldFKGeneralItem,
                    fldFKSize: state.generalPoDetailsForm?.fldFKSize,
                    fldFKColour: state.generalPoDetailsForm?.fldFKColour,
                    fldSize: state.generalPoDetailsForm?.fldSize,
                    fldGeneralItem: state.generalPoDetailsForm?.fldGeneralItem,
                }
            };
        case CREATE_GENERAL_DC_DETAILS_FORM:
        case UPDATE_GENERAL_DC_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: {
                    ...state.generalPoDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_GENERAL_DC_DETAILS_FAILURE:
        case CREATE_GENERAL_DC_DETAILS_FAILURE:
        case UPDATE_GENERAL_DC_DETAILS_FAILURE:
        case FETCH_SINGLE_GENERAL_DC_DETAILS_FAILURE:
        case DELETE_GENERAL_DC_DETAILS_FAILURE:
        case FETCH_GENERAL_DC_DETAILS_APPROVAL_STATUS_FAILURE:
        case FETCH_MISCELLANEOUS_ITEM_FAILURE:
            return {
                ...state,
                loading: false
            };

        default:
            return state;
    }
};
